"use strict";
import Account from "../api/account";
import "./indexer/address";
import "classnames";
import DisablingButton from "./disabling_button";
import documentFormatter from "../formatters/documents";
import DocumentsService from "./documents_service";
import fetch from "../util/fetch";
import { Flash } from "../components/flash_messages";
import format from "../formatters/general";
import { History } from "react-router";
import LinkedStateMixin from "react-addons-linked-state-mixin";
import Paginator from "../util/paginator";
import ToBeScrapedLoadService from "./to_be_scraped_load_service";
import WaitingSpinner from "./waiting_spinner";
var ToBeScrapedLoadsPage = React.createClass({
  mixins: [LinkedStateMixin, History],
  getInitialState: function() {
    var params = this.props.location.query;
    if (params.only_completed === "false") params.only_completed = false;
    if (params.with_documents === "false") params.with_documents = false;
    if (params.with_invoice === "false") params.with_invoice = false;
    _.each(this.documentTypes, function(type) {
      params[type] = params[type] !== "false";
    }.bind(this));
    return _.extend(params, {
      checkedLoads: [],
      loaded: false,
      updating: false,
      load_counts: { today: "", yesterday: "", month_to_date: "" }
    });
  },
  componentWillMount: function() {
    var component = this;
    this.loadCustomers();
    this.loadCarriers();
    ToBeScrapedLoadService.update().then(function() {
      component.filterData();
    });
  },
  componentWillReceiveProps: function(newProps) {
    this.props.location.query.page = newProps.location.query.page;
    this.filterData();
  },
  loadCustomers: function() {
    var component = this;
  },
  loadCarriers: function() {
    var component = this;
    $.get("/api/to_be_scraped_loads/carriers/").then(function(resp) {
      if (component.isMounted()) component.setState({ carriers: resp.carriers });
    });
  },
  updateBatches: function() {
    var batchIds = _.compact(_.map(this.state.loads, function(load) {
      return load.document_batch_id;
    }));
    return DocumentsService.getDocumentBatches(batchIds);
  },
  filterLoads: function() {
    var component = this;
    return ToBeScrapedLoadService.filtered(component.filterTerms()).then(function(data) {
      if (!component.isMounted()) return;
      component.setState({
        loads: data.to_be_scraped_loads,
        total_pages: data.total_pages,
        unmatched: data.unmatched_references
      });
      return component.updateBatches();
    });
  },
  filterTerms: function() {
    return {
      customer_id: this.state.customer_id,
      carrier: this.state.carrier,
      delivered_after: this.state.delivered_after,
      delivered_before: this.state.delivered_before,
      only_completed: this.state.only_completed,
      search_term: this.state.search_term,
      with_documents: this.state.with_documents,
      with_invoice: this.state.with_invoice,
      invoiced_after: this.state.invoiced_after,
      invoiced_before: this.state.invoiced_before,
      page: this.currentPage()
    };
  },
  filterKeys: ["customer_id", "carrier", "delivered_after", "delivered_before", "only_completed", "search_term", "with_documents", "with_invoice", "invoiced_after", "invoiced_before"],
  filterData: function(e) {
    var component = this;
    if (!_.isUndefined(e)) e.preventDefault();
    component.setState({ loaded: false });
    component.filterLoads().then(function(data) {
      if (component.isMounted()) {
        component.setState({
          loaded: true
        });
      }
    });
  },
  clearFilters: function(e) {
    e.preventDefault();
    var state = this.state;
    _.each(this.filterKeys, function(key) {
      delete state[key];
    });
    this.setState(state);
    if (!_.isEmpty(this.props.location.query)) {
      this.submitFilter(e);
    }
  },
  submitFilter: function(e) {
    if (!_.isUndefined(e)) e.preventDefault();
    var params = _.pick(this.state, this.filterKeys);
    params = _.omit(params, function(value, key, object) {
      return !value;
    });
    _.extend(params, _.pick(this.state, this.documentTypes));
    if (_.isEqual(this.props.location.query, params)) {
      return this.filterData();
    }
    this.history.pushState(null, this.props.location.pathname, params);
  },
  carrierOption: function(carrier) {
    return /* @__PURE__ */ React.createElement("option", { value: carrier.scac, key: "carrier-" + carrier.scac }, carrier.name);
  },
  customerOption: function(customer) {
    return /* @__PURE__ */ React.createElement("option", { value: customer.id, key: "customer-" + customer.id }, customer.name);
  },
  clearButton: function() {
    var component = this;
    if (!_.all(component.filterKeys, function(key) {
      return !component.state[key];
    })) {
      return /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          className: "button--cancel",
          disabled: !component.state.loaded,
          disabledText: "",
          onClick: component.clearFilters,
          disabledClassName: "button--cancel"
        },
        "Clear Filters"
      );
    }
  },
  filters: function() {
    return /* @__PURE__ */ React.createElement("form", { onSubmit: this.submitFilter }, /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement("legend", null, "Filter"), /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-2 columns" }, /* @__PURE__ */ React.createElement("label", null, "Reference", /* @__PURE__ */ React.createElement("input", { type: "text", valueLink: this.linkState("search_term") }))), /* @__PURE__ */ React.createElement("div", { className: "small-2 columns" }, /* @__PURE__ */ React.createElement("label", null, Account.carrierTerm(), /* @__PURE__ */ React.createElement("select", { valueLink: this.linkState("carrier") }, /* @__PURE__ */ React.createElement("option", { value: "" }, "-- any --"), _.map(this.state.carriers, this.carrierOption)))), /* @__PURE__ */ React.createElement("div", { className: "small-2 columns" }, /* @__PURE__ */ React.createElement("label", null, "Customer", /* @__PURE__ */ React.createElement("select", { valueLink: this.linkState("customer_id") }, /* @__PURE__ */ React.createElement("option", { value: "" }, "-- any --"), _.map(this.state.customers, this.customerOption)))), /* @__PURE__ */ React.createElement("div", { className: "small-2 columns" }, /* @__PURE__ */ React.createElement("label", null, "Delivered on or After", /* @__PURE__ */ React.createElement("input", { type: "date", valueLink: this.linkState("delivered_after") }))), /* @__PURE__ */ React.createElement("div", { className: "small-2 columns" }, /* @__PURE__ */ React.createElement("label", null, "Delivered on or Before", /* @__PURE__ */ React.createElement("input", { type: "date", valueLink: this.linkState("delivered_before") })))), /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-2 columns" }, /* @__PURE__ */ React.createElement("input", { id: "with-documents", type: "checkbox", checkedLink: this.linkState("with_documents") }), /* @__PURE__ */ React.createElement("label", { htmlFor: "with-documents" }, "With Documents")), /* @__PURE__ */ React.createElement("div", { className: "small-2 columns" }, /* @__PURE__ */ React.createElement("input", { id: "with-invoice", type: "checkbox", checkedLink: this.linkState("with_invoice") }), /* @__PURE__ */ React.createElement("label", { htmlFor: "with-invoice" }, "With Customer Invoice")), /* @__PURE__ */ React.createElement("div", { className: "small-2 columns" }, /* @__PURE__ */ React.createElement("label", null, "Invoiced After", /* @__PURE__ */ React.createElement("input", { type: "date", valueLink: this.linkState("invoiced_after") }))), /* @__PURE__ */ React.createElement("div", { className: "small-2 columns" }, /* @__PURE__ */ React.createElement("label", null, "Invoiced Before", /* @__PURE__ */ React.createElement("input", { type: "date", valueLink: this.linkState("invoiced_before") }))), /* @__PURE__ */ React.createElement("div", { className: "small-2 columns" }, "\xA0")), /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 columns" }, /* @__PURE__ */ React.createElement(
      DisablingButton,
      {
        className: "button--confirmation",
        disabled: !this.state.loaded,
        disabledText: "Loading..."
      },
      "Filter"
    ), "\xA0", this.clearButton()))));
  },
  pagination: function() {
    if (this.state.loaded) {
      return /* @__PURE__ */ React.createElement(
        Paginator,
        {
          location: this.props.location,
          numberOfPages: this.numberOfPages()
        }
      );
    }
  },
  currentPage: function() {
    return _.min([parseInt(this.props.location.query["page"] || "1"), this.numberOfPages()]);
  },
  numberOfPages: function() {
    return this.state.total_pages;
  },
  possibleUnmatchedReferences: function() {
    if (!_.isEmpty(this.state.unmatched)) {
      var term = this.state.unmatched.length === 1 ? "term" : "terms";
      var terms = _.map(this.state.unmatched, function(s) {
        return '"' + s + '"';
      });
      return /* @__PURE__ */ React.createElement("div", { className: "alert-box--caution" }, "Unable to find search ", term, ": ", _.str.toSentenceSerial(terms));
    }
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "general-container row" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("div", { className: "to-be-scraped-loads" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, this.filters())), this.possibleUnmatchedReferences(), /* @__PURE__ */ React.createElement("form", { method: "get", action: "/api/to_be_scraped_loads/bulk_download" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 column to-be-scraped-loads__document-type-filter" }, "Download Only: ", _.map(this.documentTypes, this.documentTypeFilter), /* @__PURE__ */ React.createElement(DisablingButton, { disabledText: "Select loads to download", disabled: !this.loadsAreChecked(), className: "button--confirmation", type: "submit" }, "Download Checked")), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, this.pagination()), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, this.selectAll()), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement(WaitingSpinner, { when: !this.state.loaded }, /* @__PURE__ */ React.createElement("table", { className: "to-be-scraped-loads__table" }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "\xA0"), /* @__PURE__ */ React.createElement("th", null, Account.carrierTerm()), /* @__PURE__ */ React.createElement("th", null, "Load ID"), /* @__PURE__ */ React.createElement("th", null, "Pro Number"), /* @__PURE__ */ React.createElement("th", null, "Secondary Tracking Number "), /* @__PURE__ */ React.createElement("th", null, "Invoice Number"), /* @__PURE__ */ React.createElement("th", null, "Delivered on"), /* @__PURE__ */ React.createElement("th", null, "Last Updated on"), /* @__PURE__ */ React.createElement("th", null, "Invoice Amount"), /* @__PURE__ */ React.createElement("th", null, "Available Documents"), /* @__PURE__ */ React.createElement("th", null, "Actions"))), /* @__PURE__ */ React.createElement("tbody", null, this.toBeScrapedLoadsRows())))))))));
  },
  selectAll: function() {
    if (this.state.loaded && this.state.loads.length > 0) {
      if (this.numberOfPages() === 1) {
        var label = "Select All";
      } else {
        var label = "Select Displayed";
      }
      return /* @__PURE__ */ React.createElement("label", null, /* @__PURE__ */ React.createElement("input", { id: "select-all", type: "checkbox", onChange: this.selectAllLoads }), label, " ");
    }
  },
  selectAllLoads: function() {
    if (_.isEmpty(this.state.checkedLoads)) {
      this.setState({ checkedLoads: _.pluck(this.state.loads, "id") });
    } else {
      this.setState({ checkedLoads: [] });
    }
  },
  toBeScrapedLoads: function(toBeScrapedLoadService) {
    return toBeScrapedLoadService.toBeScrapedLoads();
  },
  documentsForLoad: function(load) {
    var batch = this.batchForLoad(load);
    return batch ? batch.documents : [];
  },
  batchForLoad: function(load) {
    return DocumentsService.getFetchedDocumentBatch(load.document_batch_id);
  },
  documentsCell: function(load) {
    var documents = this.documentsForLoad(load);
    var documentList = /* @__PURE__ */ React.createElement("em", null, "No Documents");
    if (!_.isEmpty(documents)) {
      documentList = _.map(documents, this.documentCell);
    }
    return /* @__PURE__ */ React.createElement("div", null, this.maybeInvalidProAlert(load), this.maybeSignInFailedAlert(load), this.permissionDeniedAlert(load), documentList);
  },
  maybeInvalidProAlert: function(load) {
    var no_docs = _.isEmpty(this.documentsForLoad(load));
    if (no_docs && load.invalid_pro_number_detected_at) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("em", { className: "alert" }, "Pro Number Not Found"));
    }
  },
  maybeSignInFailedAlert: function(load) {
    const signInFailed = load.login_failure_detected_at && !load.last_successful_login_id;
    if (signInFailed) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("em", { className: "alert" }, "Sign In Failure"));
    }
  },
  permissionDeniedAlert: function(load) {
    if (load.permission_denied_at) {
      return /* @__PURE__ */ React.createElement("div", { className: "to-be-scraped-loads__permissions-alert" }, /* @__PURE__ */ React.createElement("i", { className: "fi-alert alert to-be-scraped-loads__permissions-alert-icon" }, " "), this.permissionDeniedAlertText());
    }
  },
  permissionDeniedAlertText: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "to-be-scraped-loads__permission-denied-alert-text" }, "Permissions problems kept us from retrieving all documents. Contact support for more information.");
  },
  documentCell: function(document, index) {
    var type = documentFormatter.title(document);
    if (_.isEmpty(type)) type = "Unknown";
    return /* @__PURE__ */ React.createElement("span", { className: "to-be-scraped-loads__document", key: "doccell-" + index }, /* @__PURE__ */ React.createElement("a", { href: document.inline_url, target: "_blank" }, /* @__PURE__ */ React.createElement("i", { className: "fi-page" }, "\xA0"), type));
  },
  toBeScrapedLoadsRows: function() {
    if (this.state.loaded) {
      if (_.isEmpty(this.state.loads)) {
        return /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { colSpan: "8", className: "to-be-scraped-loads__not-found-row" }, /* @__PURE__ */ React.createElement("div", { className: "alert-box info" }, /* @__PURE__ */ React.createElement("em", null, "No loads found."))));
      } else {
        return _.map(this.state.loads, this.toBeScrapedLoadsRow);
      }
    }
  },
  loadActions: function(load) {
    return /* @__PURE__ */ React.createElement("div", { className: "to-be-scraped-loads__actions" }, this.downloadAllDocumentsLink(load), this.requeueRetrievalLink(load.id));
  },
  requeueRetrievalLink: function(loadId) {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("a", { onClick: () => {
      this.requeueLoad(loadId);
    } }, /* @__PURE__ */ React.createElement(
      "span",
      {
        className: "indexer-header__carrier-label",
        "data-tooltip": true,
        "aria-haspopup": "true",
        title: "Retry Document Retrieval"
      },
      /* @__PURE__ */ React.createElement("i", { className: "fi-refresh to-be-scraped-loads__action-icon" })
    )));
  },
  requeueLoad: function(loadId) {
    fetch(
      "/api/to_be_scraped_loads/" + loadId + "/retry_load",
      { method: "post" }
    ).then(() => {
      Flash.success("Load successfully queued for document retrieval.");
    }).catch(() => {
      Flash.alert("There was a problem queueing that load for document retrieval.");
    });
  },
  downloadAllDocumentsLink: function(load) {
    var batch = this.batchForLoad(load);
    var documents = this.documentsForLoad(load);
    const toolTipTitle = "Download " + (this.isPartialDownload() ? "Selected" : "All");
    if (batch && !_.isEmpty(documents) && this.selectedToDownload(documents).length > 0) {
      var url = this.addTypesToDownload(batch.merged_documents_download_url);
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("a", { href: url }, /* @__PURE__ */ React.createElement(
        "span",
        {
          className: "indexer-header__carrier-label",
          "data-tooltip": true,
          "aria-haspopup": "true",
          title: toolTipTitle
        },
        /* @__PURE__ */ React.createElement("i", { className: "fi-download to-be-scraped-loads__action-icon" })
      )));
    }
  },
  addTypesToDownload: function(url) {
    if (this.isPartialDownload()) {
      var types = this.selectedDocumentTypes().join(",");
      return url + "?types=" + types;
    } else {
      return url;
    }
  },
  selectedDocumentTypes: function() {
    return _.select(this.documentTypes, function(type) {
      return this.state[type];
    }.bind(this));
  },
  selectedToDownload: function(docs) {
    return _.select(docs, function(document) {
      return this.state[document.type];
    }.bind(this));
  },
  isPartialDownload: function() {
    return !_.all(this.documentTypes, function(a) {
      return this.state[a];
    }.bind(this));
  },
  documentTypes: ["billOfLading", "proofOfDelivery", "invoice", "letterOfAssignment", "nmfcCertificate"],
  documentTypeFilter: function(type, index) {
    return /* @__PURE__ */ React.createElement("label", { key: "filter-" + index }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", name: "document_types[]", value: type, checkedLink: this.linkState(type) }), " ", documentFormatter.title({ type }));
  },
  toBeScrapedLoadsRow: function(load) {
    var key = "load_row_" + load.id;
    return /* @__PURE__ */ React.createElement("tr", { id: key, key }, /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement("input", { name: "load_ids[]", value: load.id, type: "checkbox", checked: _.contains(this.state.checkedLoads, load.id), onChange: _.partial(this.toggleLoad, load.id) })), /* @__PURE__ */ React.createElement("td", null, load.carrier_scac), /* @__PURE__ */ React.createElement("td", null, load.primary_reference), /* @__PURE__ */ React.createElement("td", null, load.pro_number), /* @__PURE__ */ React.createElement("td", null, load.secondary_tracking_number), /* @__PURE__ */ React.createElement("td", null, load.customer_invoice_number), /* @__PURE__ */ React.createElement("td", null, format.date(load.actual_delivered_at)), /* @__PURE__ */ React.createElement("td", null, this.dateTime(load)), /* @__PURE__ */ React.createElement("td", null, load.total_amount_value, " ", load.total_amount_currency), /* @__PURE__ */ React.createElement("td", null, this.documentsCell(load)), /* @__PURE__ */ React.createElement("td", { className: "to-be-scraped-loads__actions" }, this.loadActions(load)));
  },
  dateTime: function(load) {
    let date = load.last_scraped_at;
    if (date) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", null, format.shortTime(load.last_scraped_at)), /* @__PURE__ */ React.createElement("div", null, format.shortDate(load.last_scraped_at)));
    } else {
      return /* @__PURE__ */ React.createElement("div", null, "N/A");
    }
  },
  toggleLoad: function(loadId) {
    if (_.contains(this.state.checkedLoads, loadId)) {
      this.setState({ checkedLoads: _.without(this.state.checkedLoads, loadId) });
    } else {
      this.setState({ checkedLoads: this.state.checkedLoads.concat([loadId]) });
    }
  },
  loadsAreChecked: function() {
    return !_.isEmpty(this.state.checkedLoads);
  }
});
export default ToBeScrapedLoadsPage;
